// extracted by mini-css-extract-plugin
module.exports = {"totalBold":"text_totalBold__8XkDc","textColorGrey":"text_textColorGrey__3tFPW"};